import { Toolbar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {Add, PictureAsPdf} from "@mui/icons-material";//@material-ui/icons";
import React from "react";
import EnhancedIconButton from "src/components/enhanced/EnhancedIconButton";

function EnhancedVoucherTableToolbar(props) {
  const classes = useToolbarStyles();

  const { setOpenNew, label, handleMultiPdfGenerate } = props;

  return (
    <Toolbar className={classes.root}>
      <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
        {label}
      </Typography>
      <div>
        <EnhancedIconButton
          authority='voucher.edit'
          ariaLabel="add item"
          tooltip="Přidat"
          Icon={Add}
          onClick={() => setOpenNew(true)}
        />
      </div>
      <div>
        <EnhancedIconButton
          authority='voucher.edit'
          ariaLabel="add item"
          tooltip="Vygenerovat hromadné PDF"
          Icon={PictureAsPdf}
          onClick={handleMultiPdfGenerate}
        />
      </div>
    </Toolbar>
  );
}

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1)
  },
  title: {
    flex: "1 1 100%"
  },
  dNone: {
    display: "none"
  }
}));

export default EnhancedVoucherTableToolbar;
